import { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Paths } from '../../constants/paths.ts';
import { useSnackbar } from '../../contexts/snackbar.context.tsx';
import { useAuth } from '../../contexts/auth.context.tsx';
import { LoadingBackdrop } from '../../components/loading.backdrop.tsx';
import { trackEvent } from '../../utils/analytics.ts';

export const LogoutPage: FC = () => {
  const { setTokens } = useAuth();
  const navigate = useNavigate();
  const { push } = useSnackbar();

  useEffect(() => {
    trackEvent('logout');
    setTokens(undefined, undefined);
    push({ message: 'You have been logged out', type: 'success' });
    navigate(Paths.LOGIN);
  }, []);

  return <LoadingBackdrop />;
};
